import { BrandData } from "@/declarations";
import { GetProps, SubSDK } from "../types";
export interface HeliumInfo {
  apiKey: string;
  version: 1 | 2;
}
export interface HeliumProduct {
  title: string;
  description: string;
  handle: string;
  featuredImage: {
    src: string;
    width: number;
    height: number;
    altText: string;
  };
}
const apiUrl =
  "https://intelligence-dashboard-git-sid-changes-helium-team.vercel.app";

const cdnUrl = "https://d21xluao80us9l.cloudfront.net";
//const cdnUrl =
//"https://helium-intelligence-production.s3.eu-north-1.amazonaws.com";
export class HeliumSDK implements SubSDK {
  info: HeliumInfo;
  private fetcher: <T = any>(path: string, options?: RequestInit) => Promise<T>;
  constructor(props: BrandData) {
    this.info = props.helium;

    this.fetcher = async (path: string, options?: RequestInit) => {
      if (!props.apiKey) return;
      const useStore = props.useStoreId ?? props?.storeId;
      if (
        path === "products" ||
        path.includes("similar") ||
        path.includes("complementary") ||
        path.includes("tag_recommendation")
      ) {
        const res2 = await fetch(
          cdnUrl +
            `/${props.orgId}/products/${path}.${useStore ? props?.storeId + "." : ""}json`,
        );
        return res2.json();
      }
      const res2 = await fetch(
        cdnUrl + `/${props.orgId}/products/${path}.json`,
      );
      return res2.json();
      const res = await fetch(apiUrl + "/api/v2" + path, {
        ...options,
        headers: { "x-helium-api-key": this.info.apiKey },
      });
      return res.json();
    };
  }
  async getTags({ id }: GetProps) {
    return (await this.fetcher(id + "/tags")) || {};
  }
  async getSimilar({ id }: GetProps) {
    return await this.fetcher(id + "/similar");
  }
  async getComplementary({ id }: GetProps) {
    return (await this.fetcher(id + "/complementary")) || [];
  }
  async getProductDetails({ id }: GetProps) {
    return (await this.fetcher(id + "/details")) || {};
  }
  async getProducts() {
    return (await this.fetcher("products")) || [];
  }
  async getProductUiDescription({ id }: GetProps) {
    return (await this.fetcher(id + "/ui-description")) || [];
  }
  async getProductTagRecommendation({ id }: GetProps) {
    try {
      const data = await this.fetcher(id + "/tag_recommendation_v2");
      return data;
    } catch (error) {
      console.error(
        `Error fetching tag recommendations for product ${id}:`,
        error,
      );
      return null;
    }
  }
  async getFaq({ id }: GetProps) {
    const orgId = window.helium.brandData.orgId;
    const storeId = window.helium.brandData.storeId;
    const apiUrl = `${cdnUrl}/${orgId || storeId}/products/${id}/faq.json`;
    const res = await fetch(apiUrl).then((r) => r.text());
    return JSON.parse(res);
  }
}
